// The armor stacking limit counts ADDITIONAL equipped suits that stack past the primary one,
// each at half value. 0 = no stacking; 1 = SWADE core.
//
// This module is the single source of truth for what counts as a valid limit. It is store-free
// so it can be unit-tested without mounting anything, following character-local-setting.ts.

// The ceiling the authoring UI offers. Deliberately NOT normalizeArmorStackingLimit's default:
// 99 keeps the spinner sane, but nothing breaks at 100, and defaulting to it would silently
// impose an authoring affordance on the apply handler too.
export const ARMOR_STACKING_LIMIT_MAX = 99;

// Returns null when the value is not a number at all. The caller decides what that means:
// calculateToughness falls back to stock stacking (1), the apply handler ignores the
// modification, and the configurator leaves its field empty.
//
// A number is coerced into a valid limit: floored, then clamped up to 0 and down to `max`. An
// out-of-range number is clamped rather than rejected because its intent is legible — below the
// minimum maps onto the minimum.
export function normalizeArmorStackingLimit(
    value: unknown,
    max: number = Infinity,
): number | null {
    if (typeof value !== 'number' || !Number.isFinite(value)) return null;

    return Math.min(max, Math.max(0, Math.floor(value)));
}
